module.exports = __webpack_public_path__ + "static/media/cuanto-tengo-en-mi-afp.f2bb699b.png";